import React from "react";
import errorHandler from "./ErrorHandler";
var eror ={message:"failed to load component"}
class NetworkErrorHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    //catching error and redirectiung to maintaince page using approutes
    this.props.setError(eror)
  }

  render() {
    if(this.setState.hasError){
      return null
    }
    return this.props.children;
  }
}

export default     errorHandler(NetworkErrorHandler);
